/**
 * WhatsApp Utilities for Promotions Management System
 */

import { CONFIG } from './config.js';

/**
 * Format date range for message
 * @param {string} startDate - Start date
 * @param {string} endDate - End date
 * @returns {string} Formatted date range
 */
function formatDateRange(startDate, endDate) {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
}

/**
 * Generate WhatsApp deep link URL
 * @param {Object} promotion - Promotion object
 * @returns {string} WhatsApp URL
 */
export function generateWhatsAppLink(promotion) {
    const phone = promotion.contactNumber || CONFIG.promotion.defaultContactNumber;
    
    // Use custom message or default
    let message = promotion.whatsappMessage || CONFIG.promotion.defaultWhatsappMessage;
    
    // Replace all placeholders with actual values
    const dateRange = formatDateRange(promotion.startDate, promotion.endDate);
    
    message = message
        .replace(/\{title\}/gi, promotion.title || '')
        .replace(/\{dateRange\}/gi, dateRange)
        .replace(/\{venue\}/gi, promotion.venue || 'TBA')
        .replace(/\{category\}/gi, promotion.category || '');
    
    const encodedMessage = encodeURIComponent(message);
    return `https://api.whatsapp.com/send?phone=91${phone}&text=${encodedMessage}`;
}

/**
 * Format phone number for display
 * @param {string} phone - Phone number
 * @returns {string} Formatted phone number
 */
export function formatPhoneNumber(phone) {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return `${cleaned.slice(0, 5)} ${cleaned.slice(5)}`;
    }
    return phone;
}

export default { generateWhatsAppLink, formatPhoneNumber };
